import { __awaiter, __generator, __read } from "tslib";
import { useCapabilities } from '@office-start/capabilities-service';
import React from 'react';
export function useRemotableRenderer(remotableComponent, fallback) {
    var _a = __read(React.useState(null), 2), renderer = _a[0], setRenderer = _a[1];
    var capabilities = useCapabilities().data;
    React.useEffect(function () {
        function loadRemote() {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = setRenderer;
                            return [4 /*yield*/, remotableComponent()];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [2 /*return*/];
                    }
                });
            });
        }
        var remoteModulesEnabled = capabilities === null || capabilities === void 0 ? void 0 : capabilities.remoteModulesEnabled;
        if (remoteModulesEnabled != null) {
            if (remoteModulesEnabled) {
                loadRemote();
            }
            else {
                setRenderer(function () { return fallback; });
            }
        }
    }, [capabilities === null || capabilities === void 0 ? void 0 : capabilities.remoteModulesEnabled, remotableComponent, fallback]);
    return renderer;
}
//# sourceMappingURL=useRemotableRenderer.js.map